import StationElevationPlot, {StaElevPlotLayer} from "../Output/UI/StationElevationPlot";
import {AppActions, useAppContext} from "../../Context/ProjectContextV2";
import React, {useEffect, useState} from "react";
import {Result, Select} from "antd";

function PlotToolbar({onLayerChange}) {
    const {getOperationItemConfig, getSelectedRS} = useAppContext()
    const [selectedLayers, setSelectedLayers] = useState([])
    const [layerOptions, setLayerOptions] = useState([])

    const renderLayers = () => {
        const config = getOperationItemConfig()
        if(!config || !config.Plot)
            return (<></>)

        const layers = Array.from(new Set(config?.Plot?.onPlotLayers(getSelectedRS())));
        const val = getOperationItemConfig()?.Plot?.onChangeRS && getOperationItemConfig()?.Plot?.onChangeRS(getSelectedRS())

        const compare = layers.find(x => x?.includes('C:'))
        if(compare) {
            const components = []
            let base = (
                <Select.OptGroup label={'Base'}>
                    {
                        layers.filter(x => x?.includes('B:')).map((x, idx) => (
                            <Select.Option
                                key={`layer-${x}`}
                                value={x}
                                checked={layers?.find(y => y === x)}
                            >
                                {x.replaceAll('B: ', '').replaceAll('C: ', '')}
                            </Select.Option>
                        ))
                    }
                </Select.OptGroup>
            )
            let cmp = (
                <Select.OptGroup label={'Comparison'}>
                    {
                        layers.filter(x => x?.includes('C:')).map((x, idx) => (
                            <Select.Option
                                key={`layer-${x}`}
                                value={x}
                                checked={layers?.find(y => y === x)}
                            >
                                {x.replaceAll('B: ', '').replaceAll('C: ', '')}
                            </Select.Option>
                        ))
                    }
                </Select.OptGroup>
            )

            setLayerOptions([base, cmp])
        }
        else {
            setLayerOptions(layers.map((x, idx) => (
                <Select.Option
                    key={`layer-${x}`}
                    value={x}
                >
                    {x.replaceAll('B: ', '').replaceAll('C: ', '')}
                </Select.Option>
            )))
        }
    }

    useEffect(() => {
        onLayerChange && onLayerChange(selectedLayers)
    }, [selectedLayers]);

    useEffect(() => {
        setSelectedLayers(getOperationItemConfig()?.Plot?.onChangeRS && getOperationItemConfig()?.Plot?.onChangeRS(getSelectedRS()))
        renderLayers()
    }, [getSelectedRS()?.cross_section]);

    return (
        <>
            <Select
                showArrow={true}
                suffixIcon={(<b style={{marginRight: 16}}>Layers</b>)}
                style={{width: 450}}
                size={'small'}
                mode={'multiple'}
                maxTagCount={3}
                onChange={(val) => setSelectedLayers(val)}
                value={selectedLayers}
            >
                {layerOptions}
            </Select>
        </>
    )
}

export default function PlotTab({}) {
    const {dispatchProject, selectedRS, getSelectedRS, getOperationItemConfig, selectedHistoryId, selectedOperation, selectedErrorId, getCSListByErrorId} = useAppContext()
    const [selectedLayers, setSelectedLayers] = useState([])

    useEffect(() => {
    }, [selectedHistoryId, selectedOperation]);

    useEffect(() => {
        dispatchProject({
            type: AppActions.SET_MESSAGE_TOOLBAR_ITEM,
            data: {toolbar: (<PlotToolbar onLayerChange={(val) => {setSelectedLayers(val)}}/>)}
        })

        return () => {
            dispatchProject({
                type: AppActions.SET_MESSAGE_TOOLBAR_ITEM,
                data: null
            })
        }
    }, []);

    const isStructure = () => {
        return getOperationItemConfig()?.Plot?.Type === 'Structure'
    }

    useEffect(() => {
        if(selectedErrorId && getCSListByErrorId()?.length > 0 && !selectedRS) {
            dispatchProject({
                type: AppActions.SET_SELECTED_RS,
                data: {rs: getCSListByErrorId()[0]}
            })
        }
    }, [selectedErrorId]);

    return (
        <div key={`plot-tab-${selectedHistoryId}`}>
            {
                !getOperationItemConfig()?.Plot && (
                    <Result
                        title="No have plot"
                    />
                )
            }
            {
                getOperationItemConfig()?.Plot && (
                    <>
                        <StationElevationPlot
                            layers={selectedLayers}
                            locWselEnable={getOperationItemConfig()?.Plot?.locWsel}
                            globalVariables={selectedOperation?.data?.global_variables}
                            crossSection={`${getSelectedRS()?.cross_section} ${isStructure() ? 'US' : ''}`}
                            plotData={{
                                base: getSelectedRS()?.plot_base || getSelectedRS()?.plot_us_base,
                                cmp: getSelectedRS()?.plot_cmp || getSelectedRS()?.plot_us_cmp
                            }}
                        />
                        {
                            isStructure() && !getOperationItemConfig()?.Plot?.hideDS && (
                                <StationElevationPlot
                                    layers={selectedLayers}
                                    locWselEnable={getOperationItemConfig()?.Plot?.locWsel}
                                    globalVariables={selectedOperation?.data?.global_variables}
                                    crossSection={`${getSelectedRS()?.cross_section} ${isStructure() ? 'DS' : ''}`}
                                    plotData={{
                                        base: getSelectedRS()?.plot_base || getSelectedRS()?.plot_ds_base,
                                        cmp: getSelectedRS()?.plot_cmp || getSelectedRS()?.plot_ds_cmp
                                    }}
                                />
                            )
                        }
                    </>
                )
            }
        </div>
    )
}